<body *ngIf="isDisplayed">
    <div *ngFor="let gender of genders" class="filter-radio-input" >
        <input [id]="'gender-' + gender" class="radio-btn" type="radio" name="gender" [value]="gender" [(ngModel)]="genderSelected" [checked]="gender === genderSelected"/>
        <label [for]="'gender-' + gender"> {{ 'watch.ranking_modal.gender.' + gender |
            translate}}</label>
    </div>
</body>